<template>
  <z-date-range-filter
    v-bind="configuration"
    :color="color"
    :interval.sync="interval"
    :value="value"
    @input="$emit('input', {id: id, value: $event})"
  >
    <template #activator="{on, attrs}">
      <z-chip
        class="mr-1"
        x-small
        :color="color"
        :close="value && value.length > 0"
        :selected="value && value.length > 0"
        :text="computedText"
        :icon="icon"
        :icon-color="iconColor"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        @click:close="$emit('input', {id: id, value: []})"
      >
        <template #append-inner>
          <z-icon size="16" class="ml-1">$keyboard_arrow_down_rounded</z-icon>
        </template>
      </z-chip>
    </template>
  </z-date-range-filter>
</template>

<script>
import {format, parseISO} from 'date-fns'
import {enUS, ptBR} from 'date-fns/locale'

export default {
  name: 'DateType',
  props: {
    id: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },

    value: {
      type: Array,
      default: () => [],
    },

    color: {
      type: String,
      default: 'var(--primary)',
    },

    configuration: {
      type: Object,
      default: () => ({
        showValuesAsText: false,
        // ...props do z-date-range-filter
      }),
    },
    iconColor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      interval: 'custom',
    }
  },

  computed: {
    computedText() {
      const currentLocale = this.$i18n.locale

      if (!this.value?.length) return this.text

      const formattedValue = this.value.map((value) => {
        const date = parseISO(value)

        return format(date, 'P', {
          locale: currentLocale.includes('pt') ? ptBR : enUS,
        })
      })

      return this.configuration?.showValuesAsText
        ? formattedValue.join(' - ')
        : this.text
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-chip__close) {
  font-size: 12px !important;
}
</style>
